import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-affiliates-ads',
  templateUrl: './affiliates-ads.component.html',
  styleUrls: ['./affiliates-ads.component.scss']
})
export class AffiliatesAdsComponent implements OnInit {
  totalNumberOfAds = 5;
  adToDisplay = 5;
  constructor() { }

  ngOnInit() {
    //this.adToDisplay = Math.floor(Math.random()*this.totalNumberOfAds);
  }

}
